var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableRedMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1682_28717)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 21,
    height: 21,
    rx: 4,
    fill: "#FF5959"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1682_28717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 13L12.9922 13.0073H11.2148C10.9344 13.0073 10.707 12.78 10.707 12.4995C10.707 12.2191 10.9344 11.9917 11.2148 11.9917H13.5V12C14 12 13.2195 11.9917 13.5 11.9917C13.7805 11.9917 14 12.0054 14.0078 11.9917H15.7852C16.0656 11.9917 16.293 12.2191 16.293 12.4995C16.293 12.78 16.0656 13.0073 15.7852 13.0073H14.0078L14 13C13.5 13 13.7805 13 13.5 13C13.2195 13 13 13 13 13ZM18.0962 7.9038C16.8685 6.67612 15.2362 6 13.5 6C11.7638 6 10.1315 6.67612 8.9038 7.9038C7.67612 9.13148 7 10.7638 7 12.5C7 14.2362 7.67612 15.8685 8.9038 17.0962C10.1315 18.3239 11.7638 19 13.5 19C14.6886 19 15.8516 18.6761 16.8633 18.0632C17.1032 17.9179 17.1799 17.6057 17.0346 17.3659C16.8893 17.126 16.5769 17.0493 16.3371 17.1946C15.4841 17.7112 14.503 17.9844 13.5 17.9844C10.4759 17.9844 8.01562 15.5241 8.01562 12.5C8.01562 9.47594 10.4759 7.01562 13.5 7.01562C16.5241 7.01562 18.9844 9.47594 18.9844 12.5C18.9844 13.5814 18.6628 14.6339 18.0544 15.544C17.8985 15.7771 17.9612 16.0925 18.1944 16.2484C18.4275 16.4042 18.7429 16.3415 18.8988 16.1084C19.6191 15.0308 20 13.783 20 12.5C20 10.7638 19.3239 9.13148 18.0962 7.9038Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1682_28717",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1682_28717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1682_28717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1682_28717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(7 5.99463)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRedMinusIcon);
export default __webpack_public_path__ + "static/media/table-red-minus-icon.beb52993ffe8fa43bdccd34fef5bf1f3.svg";
export { ForwardRef as ReactComponent };